import CursorPaginatedAPI from "./CursorPaginatedAPI";
import { temperatureLogRoute } from "../routes";

export default class TemperatureLogAPI extends CursorPaginatedAPI {
    constructor(emitterInstance) {
        super(emitterInstance, temperatureLogRoute, "temperature-log", 500);
    }

    async ListAfter(after, params = {}) {
        return this.List({ after, ...params });
    }
}
